module.exports = __webpack_public_path__ + "img/ks.21b9dbf0.png";